/**
 * Markdown 渲染公共工具
 *
 * 法研大模型返回内容为 markdown 格式，统一在此渲染 + XSS 消毒，
 * 供 AI 问答明细等展示场景复用（与法律终端 web/src/utils/markdown.ts 同规范）。
 */
import { marked } from "marked";
import DOMPurify from "dompurify";

// GFM 表格/删除线，换行符转 <br>（贴合问答展示场景）
marked.setOptions({
  gfm: true,
  breaks: true,
});

/**
 * 将 markdown 原文渲染为安全的 HTML 字符串（已过 DOMPurify 消毒，可直接 v-html）
 * @param {string} md markdown 原文（可为空）
 * @returns {string} 消毒后的 HTML；入参为空返回空串
 */
export function renderMarkdown(md) {
  if (!md) return "";
  return DOMPurify.sanitize(marked.parse(md));
}

export default { renderMarkdown };
